'use strict';


export default function routes($stateProvider) {
  'ngInject';
  $stateProvider
    .state('help', {
      url: '/help',
      template: '<help></help>'
    });
};



// WEBPACK FOOTER //
// ./client/app/help/help.routes.ts